function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 19 15",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1.26667em"
    }
  }, props), React.createElement("g", {
    style: {
      "fillRule": "evenodd",
      "clipRule": "evenodd",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    }
  }, React.createElement("path", {
    d: "M15.978,3.97C15.978,3.418 15.531,2.97 14.978,2.97L7.478,2.97L6.278,1.37C6.089,1.118 5.793,0.97 5.478,0.97L1.978,0.97C1.426,0.97 0.978,1.418 0.978,1.97L0.978,12.97C0.978,13.522 1.426,13.97 1.978,13.97L14.978,13.97C15.531,13.97 15.978,13.522 15.978,12.97L15.978,3.97Z",
    style: {
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "1.5px"
    }
  })));
};

export default __webpack_public_path__ + "static/media/folder-outline.2702f9a9.svg";
export { SvgComponent as ReactComponent };